import actionTypes from './actionTypes'

const drawItActions = {
	saveDrawIt() {
		return {
			type: actionTypes.DRAW_IT_SAVE_DRAW_IT,
		}
	},
	cancelDrawIt() {
		return {
			type: actionTypes.DRAW_IT_CANCEL_DRAW_IT,
		}
	},
	cancelConfirm() {
		return {
			type: actionTypes.DRAW_IT_CANCEL_DRAW_IT_CONFIRMED,
		}
	},
	cancelReject() {
		return {
			type: actionTypes.DRAW_IT_CANCEL_DRAW_IT_REJECTED,
		}
	},
	changeInstructions(value) {
		return {
			type: actionTypes.DRAW_IT_CHANGE_INSTRUCTIONS,
			value,
		}
	},
	saveInstructions() {
		return {
			type: actionTypes.DRAW_IT_SAVE_INSTRUCTIONS,
		}
	},
	addReferenceMediaClick() {
		return {
			type: actionTypes.DRAW_IT_ADD_REFERENCE_MEDIA_CLICK,
		}
	},
	referenceMediaMenuClick(mediaType) {
		return {
			type: actionTypes.DRAW_IT_REFERENCE_MEDIA_MENU_CLICK,
			mediaType,
		}
	},
	uploadReferenceMedia(allowedTypes, files, force) {
		return {
			type: actionTypes.DRAW_IT_UPLOAD_REFERENCE_MEDIA,
			allowedTypes,
			files,
			force,
		}
	},
	uploadReferenceMediaError(message) {
		return {
			type: actionTypes.DRAW_IT_UPLOAD_REFERENCE_MEDIA_ERROR,
			message,
		}
	},
	cancelReferenceMediaPicker() {
		return {
			type: actionTypes.DRAW_IT_CANCEL_REFERENCE_MEDIA_PICKER,
		}
	},
	deleteReferenceMedia(icon) {
		return {
			type: actionTypes.DRAW_IT_DELETE_REFERENCE_MEDIA,
			icon,
		}
	},
	deleteReferenceMediaSuccess() {
		return {
			type: actionTypes.DRAW_IT_DELETE_REFERENCE_MEDIA_SUCCESS,
		}
	},
	requireUploadConfirmation() {
		return {
			type: actionTypes.DRAW_IT_UPLOAD_REQUIRE_CONFIRMATION,
		}
	},
	selectBackgroundImage() {
		return {
			type: actionTypes.DRAW_IT_SELECT_BACKGROUND_IMAGE,
		}
	},
	uploadBackgroundImage(allowedTypes, files, force) {
		return {
			type: actionTypes.DRAW_IT_UPLOAD_BACKGROUND_IMAGE,
			allowedTypes,
			files,
			force,
		}
	},
	uploadBackgroundImageError(message) {
		return {
			type: actionTypes.DRAW_IT_UPLOAD_BACKGROUND_IMAGE_ERROR,
			message,
		}
	},
	deleteBackgroundImage() {
		return {
			type: actionTypes.DRAW_IT_DELETE_BACKGROUND_IMAGE,
		}
	},
	deleteBackgroundImageSuccess() {
		return {
			type: actionTypes.DRAW_IT_DELETE_BACKGROUND_IMAGE_SUCCESS,
		}
	},
	cancelBackgroundImagePicker() {
		return {
			type: actionTypes.DRAW_IT_CANCEL_BACKGROUND_IMAGE_PICKER,
		}
	},
	flipBackgroundImageHorizontally() {
		return {
			type: actionTypes.DRAW_IT_FLIP_BACKGROUND_IMAGE_HORIZONTALLY,
		}
	},
	flipBackgroundImageVertically() {
		return {
			type: actionTypes.DRAW_IT_FLIP_BACKGROUND_IMAGE_VERTICALLY,
		}
	},
	resetBackgroundImageProperties() {
		return {
			type: actionTypes.DRAW_IT_RESET_BACKGROUND_IMAGE_PROPERTIES,
		}
	},
	rotateBackgroundImage(rotation) {
		return {
			type: actionTypes.DRAW_IT_ROTATE_BACKGROUND_IMAGE,
			rotation,
		}
	},
	scaleBackgroundImage(scale) {
		return {
			type: actionTypes.DRAW_IT_SCALE_BACKGROUND_IMAGE,
			scale,
		}
	},
	toggleHeader() {
		return {
			type: actionTypes.DRAW_IT_TOGGLE_HEADER,
		}
	},
	validateReferenceMediaSuccess(uploadId) {
		return {
			type: actionTypes.DRAW_IT_VALIDATE_REFERENCE_MEDIA_SUCCESS,
			uploadId,
		}
	},
	validateBackgroundImageSuccess(uploadId) {
		return {
			type: actionTypes.DRAW_IT_VALIDATE_BACKGROUND_IMAGE_SUCCESS,
			uploadId,
		}
	},
	addTimer() {
		return {
			type: actionTypes.DRAW_IT_ADD_TIMER,
		}
	},
	editTimer() {
		return {
			type: actionTypes.DRAW_IT_EDIT_TIMER,
		}
	},
	deleteTimer() {
		return {
			type: actionTypes.DRAW_IT_DELETE_TIMER,
		}
	},
	saveTimer(value) {
		return {
			type: actionTypes.DRAW_IT_SAVE_TIMER,
			value,
		}
	},
	saveTimerError(previous_timer) {
		return {
			type: actionTypes.DRAW_IT_TIMER_SAVE_ERROR,
			previous_timer,
		}
	},
	saveTimerSuccess() {
		return {
			type: actionTypes.DRAW_IT_TIMER_SAVE_SUCCESS,
		}
	},
	cancelTimer() {
		return {
			type: actionTypes.DRAW_IT_CANCEL_TIMER,
		}
	},
	changeImageOffset(offsetX, offsetY) {
		return {
			type: actionTypes.DRAW_IT_CHANGE_IMAGE_OFFSET,
			offsetX,
			offsetY,
		}
	},
	deleteAudioPlayer() {
		return {
			type: actionTypes.DRAW_IT_AUDIO_PLAYER_DELETE_CONFIRM,
		}
	},
	cancelAudioPlayerDelete() {
		return {
			type: actionTypes.DRAW_IT_AUDIO_PLAYER_DELETE_CANCELLED,
		}
	},
	confirmAudioPlayerDelete() {
		return {
			type: actionTypes.DRAW_IT_AUDIO_PLAYER_DELETE_CONFIRMED,
		}
	},
	deleteAudioRecorder(hasAudioRecorded) {
		return {
			type: actionTypes.DRAW_IT_AUDIO_RECORDER_DELETE_CONFIRM,
			hasAudioRecorded,
		}
	},
	cancelAudioRecorderDelete() {
		return {
			type: actionTypes.DRAW_IT_AUDIO_RECORDER_DELETE_CANCELLED,
		}
	},
	confirmAudioRecorderDelete() {
		return {
			type: actionTypes.DRAW_IT_AUDIO_RECORDER_DELETE_CONFIRMED,
		}
	},
}

export default drawItActions
